export default __webpack_public_path__ + "static/media/instagram.7bf365bb.svg";